import Main from './main';
import Edit from './edit';
import Single from './single';
import BlankInvoices from './blank-invoices';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/delta',
    Component: Main,
    props: {
      exact: true,
      isDelta: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
  {
    path: '/newFile',
    Component: Edit,
    props: {
      isNew: true,
      isFile: true,
    },
  },
];

export default routes;
